<template>
  <div class="expertise">
    <!-- 1 -->
    <div class="m-expertise__section layout layout--full-width">
      <div class="blocks ms-row collapsed">
        <div class="block-right block-below">
          <div class="image-holder">
            <picture>
              <source
                media="(min-width: 1024px)"
                srcset="../assets/imgs/CMS-pages/expertise/visuel.jpg, ../assets/imgs/CMS-pages/expertise/visuel@2x.jpg 2x"
              />
              <source
                media="(min-width: 768px)"
                srcset="../assets/imgs/CMS-pages/expertise/visuel-md.jpg, ../assets/imgs/CMS-pages/expertise/visuel-md@2x.jpg 2x"
              />
              <source
                media="(min-width: 0px)"
                srcset="../assets/imgs/CMS-pages/expertise/visuel.jpg, ../assets/imgs/CMS-pages/expertise/visuel@2x.jpg 2x"
              />
              <img
                class="lazyloaded"
                alt="Expertise"
                srcset="../assets/imgs/CMS-pages/expertise/visuel@2x.jpg 2x"
                src="../assets/imgs/CMS-pages/expertise/visuel.jpg"
              />
            </picture>
          </div>
        </div>
        <div class="block-left col-xs-12 col-sm-7" style="background-color: #7c9d5c;">
          <div class="blocks-content">
            <div class="lazy-frame ms-row center-xs">
              <div class="frame-content col-xs-10 col-md-6 text--center">
                <h1 class="expertise-title text--center" style="color: #fff;">
                  Sisley,
                  <br />c’est avant tout l’expertise.
                </h1>
                <h3
                  class="block-description text--center"
                  style="color: #fff;"
                >En se basant sur la phyto-cosmétologie, la marque propose des produits aussi efficaces qu’adaptés à toutes les peaux. Faites l’expérience de la puissance du végétal associé au meilleur de la cosmétique.</h3>
                <div class="controls-wrapper" v-if="0">
                  <div class="blocks-play text--center">
                    <div class="play-button"></div>
                  </div>
                  <div href="#" class="heading-h3" style="color: #fff;">Voir le film</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 2 -->
    <div class="m-expertise__section layout layout--full-width">
      <div class="expertise-heading">
        <div class="ms-row">
          <div class="col-xs-12">
            <h3 class="text--center">SISLEY法国希思黎的专长</h3>
            <h1 class="m-expertise__title--secondary text--center">植物美容学</h1>
          </div>
        </div>
      </div>
      <div class="blocks blocks-third">
        <div class="block-right">
          <picture>
            <source media="(min-width: 1024px)" srcset="../assets/imgs/CMS-pages/expertise/img-2.jpg, ../assets/imgs/CMS-pages/expertise/img-2@2x.jpg 2x" />
            <source media="(min-width: 768px)" srcset="../assets/imgs/CMS-pages/expertise/img-2-xs.jpg, ../assets/imgs/CMS-pages/expertise/img-2.jpg 2x" />
            <source media="(min-width: 0px)" srcset="../assets/imgs/CMS-pages/expertise/img-2-xs.jpg, ../assets/imgs/CMS-pages/expertise/img-2-xs@2x.jpg 2x" />
            <img class="lazyloaded" srcset="../assets/imgs/CMS-pages/expertise/img-2@2x.jpg 2x" src="../assets/imgs/CMS-pages/expertise/img-2.jpg" />
          </picture>
        </div>
        <div class="ms-row center-md">
          <div
            class="col-xs-12 col-sm-9 col-sm-offset-1 col-md-7 col-md-offset-0 expertise-content"
          >
            <div class="block-left">
              <div class="content-shadow text--left">
                <picture>
                  <source media="(min-width: 1024px)" srcset="../assets/imgs/CMS-pages/expertise/phyto-bg.jpg, ../assets/imgs/CMS-pages/expertise/phyto-bg@2x.jpg 2x" />
                  <source media="(min-width: 768px)" srcset="../assets/imgs/CMS-pages/expertise/phyto-bg.jpg, ../assets/imgs/CMS-pages/expertise/phyto-bg.jpg 2x" />
                  <img class="lazyloaded" srcset="../assets/imgs/CMS-pages/expertise/phyto-bg@2x.jpg 2x" src="../assets/imgs/CMS-pages/expertise/phyto-bg.jpg" />
                </picture>
              </div>
              <div class="blocks-content">
                <div class="ms-row center-sm text--left content-inner">
                  <div class="col-xs-10 col-xs-offset-1 col-sm-8 col-sm-offset-0 col-md-6">
                    <h2 class="blocks-title" style="color: #9db95e;">将植物知识与肌肤知识相融合。Sisley法国希思黎的核心创造理念就是植物美容学。</h2>
                    <p class="expertise-description" style="color: #fff;">每一种植物精萃都蕴含着能发挥特定功效的活性成分，其组合能优化每种植物精萃的功效，多方面满足并各种所有皮肤类型的需求。</p>
                    <div class="c-button c-button-secondary">发现sisley法国希思黎护理产品</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 3 -->
    <div class="m-expertise__section layout layout--full-width">
      <div class="content-block">
        <div class="block-background">
          <picture>
            <source media="(min-width: 1024px)" srcset="../assets/imgs/CMS-pages/expertise/doc.jpg, ../assets/imgs/CMS-pages/expertise/doc@2x.jpg 2x" />
            <source media="(min-width: 768px)" srcset="../assets/imgs/CMS-pages/expertise/doc-md.jpg, ../assets/imgs/CMS-pages/expertise/doc-md@2x.jpg 2x" />
            <source media="(min-width: 0px)" srcset="../assets/imgs/CMS-pages/expertise/doc-xs.jpg, ../assets/imgs/CMS-pages/expertise/doc-xs@2x.jpg 2x" />
            <img class="lazyloaded" srcset="../assets/imgs/CMS-pages/expertise/doc@2x.jpg 2x" src="../assets/imgs/CMS-pages/expertise/doc.jpg" />
          </picture>
        </div>
        <div class="block-center">
          <div class="ms-row center-sm">
            <div class="col-xs-12 col-sm-8 col-md-6 expertise-content">
              <div class="content-block-content" style="background: #fff;">
                <div class="block-content-inner">
                  <div class="ms-row center-xs">
                    <div class="col-xs-8 col-md-6 text--left expertise-heading">
                      <h3>SISLEY法国希思黎的专长</h3>
                      <h1 class="expertise-title">集中功效</h1>
                    </div>
                  </div>
                  <div class="ms-row center-xs">
                    <div class="col-xs-8 col-md-6 text--left">
                      <h2 class="title-third">多年来，Recherche Sisley法国希思黎研究室为每条产品线开发了独特的方法。品牌的成功以其实验室的创新实力为依托。时刻紧贴前沿的护肤科技，并与科学家和大学研究团队紧密合作，才能够研发出有效的护肤产品，其效能都经过专家和皮肤科医生评估。</h2>
                    </div>
                  </div>
                  <div class="ms-row center-xs">
                    <div class="col-xs-10 col-md-7 text--center">
                      <div class="c-content-block__image-holder">
                        <picture>
                          <source media="(min-width: 1024px)" srcset="../assets/imgs/CMS-pages/expertise/composition.png, ../assets/imgs/CMS-pages/expertise/composition@2x.png 2x" />
                          <source media="(min-width: 768px)" srcset="../assets/imgs/CMS-pages/expertise/composition.png, ../assets/imgs/CMS-pages/expertise/composition.png 2x" />
                          <source media="(min-width: 0px)" srcset="../assets/imgs/CMS-pages/expertise/composition.png, ../assets/imgs/CMS-pages/expertise/composition@2x.png 2x" />
                          <img class="lazyloaded" srcset="../assets/imgs/CMS-pages/expertise/composition@2x.png 2x" src="../assets/imgs/CMS-pages/expertise/composition.png" />
                        </picture>
                      </div>
                    </div>
                  </div>
                  <div class="ms-row center-xs">
                    <div class="col-xs-8 col-md-6 text--left">
                      <h2 class="m-expertise__title--third">研发过程不计时间，不计成本，始终坚持以高科技的方式提取植物种有效的活性成分，经过精准的配比生产出安全、有效、愉悦的产品。其中许多产品现在已成为高端护肤品的国际标杆：</h2>
                      <br />
                      <br />
                      <h2 class="m-expertise__title--fourth">
                        <a style="font-size: 1.5625rem; text-decoration: none;" href="/category/151" target="_blank" rel="nofollow">希思黎抗皱修活御致臻颜霜</a>,
                        <a style="font-size: 1.5625rem; text-decoration: none;" href="/category/154" target="_blank" rel="nofollow">全能乳液</a>,
                        <a style="font-size: 1.5625rem; text-decoration: none;" href="/category/155" target="_blank" rel="nofollow">赋活聚水保湿乳</a>,
                        <a style="font-size: 1.5625rem; text-decoration: none;" href="/category/153" target="_blank" rel="nofollow">黑玫瑰焕采精华霜</a>…
                      </h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="c-content-block__extra text--right">
          <picture>
            <source media="(min-width: 1024px)" srcset="../assets/imgs/CMS-pages/expertise/creme.jpg, ../assets/imgs/CMS-pages/expertise/creme@2x.jpg 2x" />
            <source media="(min-width: 768px)" srcset="../assets/imgs/CMS-pages/expertise/creme.jpg, ../assets/imgs/CMS-pages/expertise/creme@2x.jpg 2x" />
            <source media="(min-width: 0px)" srcset="../assets/imgs/CMS-pages/expertise/creme-xs.jpg, ../assets/imgs/CMS-pages/expertise/creme-xs@2x.jpg 2x" />
            <img class="lazyloaded" src="../assets/imgs/CMS-pages/expertise/creme.jpg" srcset="../assets/imgs/CMS-pages/expertise/creme@2x.jpg 2x" />
          </picture>
        </div>
      </div>
    </div>
    <!-- 4 -->
    <div class="m-expertise__section layout layout--full-width">
      <div class="c-2blocks c-2blocks--secondary">
        <div class="c-2blocks__block-left c-2blocks__block-left--absolute col-xs-12 col-sm-7 col-md-6">
          <picture>
            <source media="(min-width: 1024px)" srcset="../assets/imgs/CMS-pages/expertise/fond-zebre.jpg, ../assets/imgs/CMS-pages/expertise/fond-zebre@2x.jpg 2x">
            <source media="(min-width: 768px)" srcset="../assets/imgs/CMS-pages/expertise/fond-zebre-md.jpg, ../assets/imgs/CMS-pages/expertise/fond-zebre-md@2x.jpg 2x">
            <source media="(min-width: 0px)" srcset="../assets/imgs/CMS-pages/expertise/fond-zebre-xs.jpg, ../assets/imgs/CMS-pages/expertise/fond-zebre-xs@2x.jpg 2x">
            <img class="image--full-width lazyloaded" alt="专长" srcset="../assets/imgs/CMS-pages/expertise/fond-zebre@2x.jpg 2x" src="../assets/imgs/CMS-pages/expertise/fond-zebre.jpg">
          </picture>
        </div>
        <div class="c-2blocks__block-right c-2blocks__block-right--relative col-xs-12 col-sm-10" style="background-color: #101010;">
          <div class="c-2blocks__content c-2blocks__content--padding col-xs-12 col-sm-9 col-sm-offset-2 col-md-6 text--center">
            <div class="c-2blocks__title">
              <div class="ms-row center-md m-expertise__heading">
                <div class="col-xs-9 col-xs-offset-1 col-sm-8 col-sm-offset-0 text--left">
                  <h3 style="color: #fff;">SISLEY法国希思黎的专长</h3>
                  <h1 class="m-expertise__title--secondary" style="color: #fff;">将护肤运用于彩妆</h1>
                </div>
              </div>
            </div>
            <div class="c-2blocks__image-holder">
              <div class="ms-row center-xs">
                <div class="col-xs-12 text--center">
                  <picture>
                    <source media="(min-width: 1024px)" srcset="../assets/imgs/CMS-pages/expertise/phyto-rouge-photo-ambiance-13.jpg, ../assets/imgs/CMS-pages/expertise/phyto-rouge-photo-ambiance-13@2x.jpg 2x">
                    <source media="(min-width: 768px)" srcset="../assets/imgs/CMS-pages/expertise/phyto-rouge-photo-ambiance-13.jpg, ../assets/imgs/CMS-pages/expertise/phyto-rouge-photo-ambiance-13@2x.jpg 2x">
                    <source media="(min-width: 0px)" srcset="../assets/imgs/CMS-pages/expertise/phyto-rouge-photo-ambiance-13.jpg, ../assets/imgs/CMS-pages/expertise/phyto-rouge-photo-ambiance-13@2x.jpg 2x">
                    <img class=" lazyloaded" alt="专长" srcset="../assets/imgs/CMS-pages/expertise/phyto-rouge-photo-ambiance-13@2x.jpg 2x" src="../assets/imgs/CMS-pages/expertise/phyto-rouge-photo-ambiance-13.jpg">
                  </picture>
                </div>
              </div>
            </div>
            <div class="ms-row center-xs start-sm center-md">
              <div class="col-xs-10 col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-0 text--left">
                <h2 class="c-2blocks__description m-expertise__title--third" style="color: #ab5958;">因为化妆品全天接触肌肤，所以Sisley法国希思黎开创性地设计出全套彩妆产品系列，其中的每款产品都蕴含着品牌的护肤专业知识。</h2>
                <!--<p style="color: #fff;">Les actifs utilisés préservent l’hydratation de la peau, son confort et l'aident à mieux se défendre contre les agressions externes. Plongez dans un univers de nuances lumineuses, de textures performantes et sensorielles et de technologies les plus avant-gardistes (pigments enrobés et micronisés, poudres multi-compactées)… </p>-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 5 -->
    <div class="m-expertise__section layout layout--full-width">
      <div class="c-content-block c-content-block--secondary">
        <div class="c-content-block__background">
          <div class="c-content-block__content layout">
            <div class="c-content-block__content-inner">
              <div class="ms-row">
                <div class="col-xs-10 col-xs-offset-1 col-sm-7 col-md-9">
                  <div class="heading-h1 c-content-block__supratitle">嗅觉创意</div>
                </div>
              </div>
              <div class="ms-row m-expertise__heading">
                <div class="col-xs-10 col-xs-offset-1 col-sm-7 col-md-3">
                  <h1 class="m-expertise__title--secondary">一种感情。 <br>一份回忆。 <br>一款香氛。</h1>
                </div>
              </div>
              <div class="ms-row">
                <div class="col-xs-10 col-xs-offset-1 col-sm-8 col-md-5">
                  <h2 class="m-expertise__title--third c-content-block__description">修伯特与伊莎贝尔•多纳诺在其艺术灵感的指引下构思出彰显其独特气质与个性的设计师香氛。这些由绝妙精萃组成的非凡香氛，每一款都有自己的故事。</h2>
                </div>
              </div>
              <div class="ms-row">
                <div class="col-xs-10 col-xs-offset-1 col-sm-7 col-md-3">
                  <router-link class="c-button c-button--secondary" to="/landing?key=perfume1plp">浏览所有香氛</router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="c-content-block__center">
          <picture>
            <source media="(min-width: 1024px)" srcset="../assets/imgs/CMS-pages/expertise/el-0-b-3572-ok-copy-2.jpg, ../assets/imgs/CMS-pages/expertise/el-0-b-3572-ok-copy-2@2x.jpg 2x">
            <source media="(min-width: 768px)" srcset="../assets/imgs/CMS-pages/expertise/el-0-b-3572-ok-copy-2-md.jpg, ../assets/imgs/CMS-pages/expertise/el-0-b-3572-ok-copy-2-md@2x.jpg 2x">
            <source media="(min-width: 0px)" srcset="../assets/imgs/CMS-pages/expertise/el-0-b-3572-ok-copy-2-xs.jpg, ../assets/imgs/CMS-pages/expertise/el-0-b-3572-ok-copy-2-xs@2x.jpg 2x">
            <img class=" lazyloaded" alt="Expertise" srcset="../assets/imgs/CMS-pages/expertise/el-0-b-3572-ok-copy-2@2x.jpg 2x" src="../assets/imgs/CMS-pages/expertise/el-0-b-3572-ok-copy-2.jpg">
          </picture>
        </div>
        <div class="c-content-block__extra">
          <div class="layout ms-row center-xs">
            <div class="col-xs-8 col-xs-offset-1 col-sm-10 col-sm-offset-0 text--right">
              <h2 class="m-expertise__title--third">“我们用心经营。”</h2>
              <h4>修伯特与伊莎贝尔•多纳诺</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
.expertise {
  padding-top: 70px;
  .ms-row.collapsed { margin-right: 0; margin-left: 0; }
  .block-below { z-index: 0; }
  .block-right { position: relative; }
  .block-left {
    position: relative; padding: 88px 0 93px;
    .blocks-content { height: 100%; }
    .lazy-frame { height: 100%; display: flex; flex-direction: column; justify-content: center; }
    .center-xs { text-align: center; justify-content: center; }
    .frame-content {
      flex-basis: auto; z-index: 2; align-self: center;
      .expertise-title { font-size: 3.125rem; margin-bottom: 1rem; }
      .block-description { margin: 0.9375rem 0 3.125rem; }
      .blocks-play {
        position: relative; margin-bottom: 0.875rem;
        &::before { content: ""; width: 3.75rem; height: 2.25rem; margin: 0 auto; display: block; }
        .play-button {
          background: transparent; border: 0.0625rem solid #fff;
          &:hover {
            background: #fff;
            &::before { border-color: transparent transparent transparent #000; }
          }
          &::before { border-color: transparent transparent transparent #fff; }
        }
      }
      .play-button {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 3.75rem;
        height: 2.5rem;
        background-color: #fff;
        border-radius: 1.375rem;
        z-index: 1;
        cursor: pointer;
        transition: all 0.2s linear;
        &::before {
          content: "";
          display: block;
          width: 0;
          height: 0;
          border-color: transparent transparent transparent #000;
          border-style: inset inset inset solid;
          border-width: 7px 0 7px 7px;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
    }
  }
  .expertise-heading { margin: 4.625rem 0 1.375rem; }
  .blocks-third {
    position: relative; overflow: hidden; padding-bottom: 6.625rem; margin-bottom: 6.25rem;
    .block-right {
      width: 100%;
      z-index: 0;
      left: 0;
      display: flex;
      align-items: flex-end;
      justify-content: flex-end;
      position: absolute;
      bottom: 0;
    }

    .block-left { top: 0; z-index: auto; padding: 0; }
    .content-shadow { display: none; }
    .blocks-content {
      background: linear-gradient(127deg, #000 65%, rgba(0, 0, 0, 0.6)); width: 100%; padding: 10.5rem 1rem 14.625rem;
      .content-inner {
        min-width: 100%;
        .blocks-title { margin-bottom: 1.875rem; font-size: 1.5625rem; }
        .expertise-description { margin: 0.9375rem 0 3.125rem; }
      }
    }
  }
  .expertise-content { max-width: 50rem; }
  .c-button-secondary { background-color: transparent; border-color: #fff; color: #fff; }
  .content-block {
    padding: 0 0 3.8125rem;
    .content-block-content { position: relative; padding: 2.0625rem 0; }
    .block-content-inner { position: relative; z-index: 2; }
    .expertise-heading { margin: 0 0 3.125rem; }
    .expertise-title { font-size: 3.125rem; }
    .title-third { font-size: 1.5625rem; }
  }
  // 4
  .c-2blocks--secondary { margin-bottom: 6.25rem; 
    .c-2blocks__block-left--absolute {
      position: absolute; height: calc(100% + 6.25rem); 
      .image--full-width { height: 100%; object-fit: cover; object-position: center; }
    }
    .c-2blocks__block-right--relative { position: relative; }
  }
  // 5
  .c-content-block__supratitle { font-family: HelveticaNeueLTW05-75Bold,arial,sans-serif; }
}
// 4
.c-2blocks__block-left { position: relative; padding: 5.5rem 0 5.8125rem; }
.c-2blocks--secondary .c-2blocks__block-left { padding: 0; }
.c-2blocks__block-right { position: relative; }
.c-2blocks--secondary .c-2blocks__block-right { position: absolute; top: 0; }
.c-2blocks__content { height: 100%; }
.c-2blocks--secondary .c-2blocks__content { position: relative; display: flex; justify-content: center; flex-direction: column; padding: 5.8125rem 0 4.75rem; }
.c-2blocks--secondary .c-2blocks__title { position: relative; }
.m-expertise__heading { margin: 4.625rem 0 1.375rem; }
.c-2blocks--secondary .m-expertise__heading { margin: 0; }
.m-expertise__title--secondary { font-size: 1.875rem; }
.c-2blocks--secondary .c-2blocks__image-holder { margin: -2.5rem 0 2.5rem; }
.m-expertise__title--third { font-size: 1.5625rem; }
.c-2blocks__description { margin: .9375rem 0 3.125rem; }
// 5
.c-content-block { padding: 0 0 3.8125rem; }
.c-content-block--secondary { padding-bottom: 0; }
.c-content-block__content { position: relative; padding: 2.0625rem 0; }
.c-content-block--secondary .c-content-block__content { padding: 4.9375rem 0 0; }
.c-content-block__content-inner { position: relative; z-index: 2; }
.c-content-block__supratitle { font-size: 2.8125rem; font-family: helvetica-neue-bold,arial,sans-serif; }
.c-content-block .m-expertise__heading { margin: 0 0 3.125rem; }
.c-content-block--secondary .m-expertise__heading { margin: .625rem -.625rem; }
.m-expertise__title--secondary { font-size: 1.875rem; }
.c-content-block__description { margin: .9375rem 0 3.125rem; }
.m-expertise__section .c-content-block__description { color: #000; }
.c-content-block--secondary .c-content-block__extra { width: 100%; position: absolute; left: 0; bottom: 6.25rem; }

@media screen and (min-width: 768px) {
  .expertise {
    .blocks { padding-bottom: 215px; }
    .block-right { width: 50%; height: 100%; position: absolute; top: 0; right: 0; z-index: 2; }
    .block-left { top: 215px; padding: 280px 0 190px; position: relative; z-index: 1; }
    .blocks-third {
      padding-bottom: 10.625rem; margin-bottom: 10rem;
      .block-right { z-index: 1; }
      .content-shadow { display: block; }
      .blocks-content { position: absolute; top: 2.9375rem; left: 2.9375rem; padding: 0; display: flex; align-items: center; justify-content: center; z-index: 1; }
    }
    .content-block {
      .content-block-content { padding: 8.3125rem 0; }
    }
    // 4
    .c-2blocks--secondary .c-2blocks__block-left--absolute { height: 100%; }
  }
  .center-sm { justify-content: center; }
  .c-button { font-size: 0.75rem; padding: 0.9375rem 1.875rem; }
  .content-block {
    padding: 19rem 0 35.4375rem;
    .block-background { width: 100%; position: absolute; top: 0; left: 0; }
    .c-content-block__extra { width: 100%; position: absolute; right: 0; bottom: 0; }
  }
  // 4
  .c-2blocks { padding-bottom: 13.4375rem; }
  .c-2blocks--secondary { margin-bottom: 6.25rem; padding-bottom: 0; }
  .c-2blocks__block-left { top: 13.4375rem; padding: 17.5rem 0 11.875rem; position: relative; z-index: 1; }
  .c-2blocks--secondary .c-2blocks__block-left { top: 6.25rem; padding: 0; }
  .c-2blocks__block-right { width: 50%; height: 100%; position: absolute; top: 0; right: 0; z-index: 2; }
  .c-2blocks--secondary .c-2blocks__block-right { width: 80%; left: 20%; }
  .m-expertise__heading { margin: 4.625rem 0 2.3125rem; }
  .m-expertise__title--secondary { font-size: 3.125rem; }
  // 5
  .c-content-block { padding: 19rem 0 35.4375rem; }
  .c-content-block--secondary { padding: 39.4375rem 0 0; }
  .c-content-block__background { width: 100%; position: absolute; top: 0; left: 0; }
  .c-content-block__content { padding: 8.3125rem 0; }
  .c-content-block__supratitle { font-size: 5rem; }
  .m-expertise__title--secondary { font-size: 3.125rem; }
  .c-content-block__extra { width: 100%; position: absolute; right: 0; bottom: 0; }
  .c-content-block--secondary .c-content-block__extra { bottom: 16.125rem; }
}
@media screen and (min-width: 1024px) {
  .expertise {
    .blocks { padding-bottom: 100px; }
    .block-left { top: 100px; left: 0; }
    .blocks-third { margin-bottom: 12.5rem; }
    .center-md { text-align: center; justify-content: center; }
    .content-block { padding: 34rem 0 15.625rem; z-index: 1; }
  }
  // 4
  .c-2blocks { padding-bottom: 6.25rem; }
  .c-2blocks--secondary { padding-bottom: 0; }
  .c-2blocks__block-left { top: 6.25rem; left: 0; }
  .m-expertise__heading { margin: 6.25rem 0 2.3125rem; }
  // 5
  .c-content-block { padding: 34rem 0 15.625rem; z-index: 1; }
  .c-content-block--secondary { padding: 39.4375rem 0 0; }
  .c-content-block__supratitle { font-size: 7.5rem; }
  .c-content-block--secondary .c-content-block__extra { bottom: 32.5rem; }
}
@media screen and (min-width: 1200px) {
  .expertise {
    .block-left {
      .lazy-frame { flex-direction: row; justify-content: flex-end; }
      .frame-content { max-width: 491px; right: 22%; position: relative; }
    }
    // 4
    .c-2blocks--secondary .c-2blocks__content--padding { padding-top: 5.8125rem; padding-bottom: 5.8125rem; }
  }
}
</style>